import { Component } from '@angular/core';

@Component({
  selector: 'app-facebook-icon',
  standalone: true,
  template: `
   <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M16 8C16 3.58127 12.4187 0 8 0C3.58127 0 0 3.58127 0 8C0 11.9938 2.925 15.3031 6.75 15.9031V10.3125H4.71873V8H6.75V6.2375C6.75 4.2328 7.94377 3.125 9.77187 3.125C10.6469 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5531C9.55937 5.25 9.25 5.8672 9.25 6.5V8H11.4687L11.1141 10.3125H9.25V15.9031C13.075 15.3031 16 11.9938 16 8Z" fill="#1877F2"/>
<path d="M11.1141 10.3125L11.4688 8H9.25002V6.5C9.25002 5.8672 9.55938 5.25 10.5532 5.25H11.5625V3.28125C11.5625 3.28125 10.6469 3.125 9.77188 3.125C7.94378 3.125 6.75002 4.2328 6.75002 6.2375V8H4.71875V10.3125H6.75002V15.9031C7.15782 15.9672 7.57502 16 8.00002 16C8.42502 16 8.84222 15.9672 9.25002 15.9031V10.3125H11.1141Z" fill="white"/>
</svg>

  `,
  styles: []
})
export class FacebookIconComponent {}